import { render, staticRenderFns } from "./TariffPage.vue?vue&type=template&id=126a158f&scoped=true&"
import script from "./TariffPage.vue?vue&type=script&lang=js&"
export * from "./TariffPage.vue?vue&type=script&lang=js&"
import style0 from "./TariffPage.vue?vue&type=style&index=0&id=126a158f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a158f",
  null
  
)

export default component.exports